import { clientFetch } from "@/utils/service";
import { FETCH_PRICES } from './types';
import { qsToObj } from "@/utils/helpers";

export const fetchPricesApi = async (query) => clientFetch('/services', { query });
export const fetchNutritionServicesApi = async () => clientFetch('/nutrition-services');
export const fetchPrices = (qs) => {
  const query = !!qs ? qsToObj(qs) : {};
  return {
    type: FETCH_PRICES,
    payload: fetchPricesApi(query),
  };
};
